import { cx } from "shared/utils/classnames";

export const StepProgress = ({
  currentStep,
  totalSteps,
  className
}: {
  currentStep: number;
  totalSteps: number;
  className?: string;
}) => {
  return (
    <div className={cx("px-6 space-y-4", className)}>
      <p className="text-xs font-medium text-content-400">
        Step {currentStep}/{totalSteps}
      </p>
      <div className="flex gap-2 w-full">
        {Array.from({ length: totalSteps }).map((_, i) => (
          <div
            key={`step-${i}`}
            className={cx(
              "h-0.5 rounded-full w-full",
              i < currentStep ? "bg-primary-500" : "bg-alpha-100"
            )}
          />
        ))}
      </div>
    </div>
  );
};
